import Reveal from "../ui/Reveal";
import GetApp from "../ui/GetApp";
import { Check } from "../ui/icons";
import { TRIAL_DAYS } from "../data/pricing";
import "./cta.css";

/*
 * The close: one solid raspberry card, the same in either appearance. No
 * devices; by this point the reader has seen the app, and the last screen's
 * only job is the ask. One main button, as on the first screen.
 */
export default function Cta() {
  return (
    <section className="section cta" id="get" data-cta-end="true">
      <div className="container container--wide">
        <div className="cta__card">
          <Reveal>
            <h2 className="cta__title">Open it tomorrow morning and see what needs you.</h2>
            <p className="t-lead cta__lead">
              Free to start, with your own members in it. No card, and nothing
              to uninstall if you walk away.
            </p>
          </Reveal>

          <Reveal delay={0.08} className="cta__side">
            <GetApp className="cta__actions" />
            <ul className="cta__fine">
              <li>
                <Check />
                {TRIAL_DAYS} days free, no card
              </li>
              <li>
                <Check />
                Trainers sign in free
              </li>
              <li>
                <Check />
                Export your data any time
              </li>
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
